import React from 'react';
import { useBrandingColors } from '../../hooks/useBrandingColors';

interface CustomCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  className?: string;
  disabled?: boolean;
}

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
  checked,
  onChange,
  label,
  className = '',
  disabled = false,
}) => {
  const colors = useBrandingColors();

  return (
    <label
      className={`flex items-center space-x-2 ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="h-4 w-4 border-gray-300 rounded shrink-0"
        style={{
          accentColor: colors.primary,
          color: colors.primary,
        }}
      />
      <span className="text-sm text-gray-700 flex-1">{label}</span>
    </label>
  );
};

export default CustomCheckbox;
